import { subscriptionsApi } from '@features/subscriptions/store/api';
import { enhancedApi } from '@store/generated/labs';

// Enhance the generated API with cache tags
export const labOrdersApi = enhancedApi.enhanceEndpoints({
  addTagTypes: ['LabOrders', 'AvailableLabs', 'LabRecommendations', 'LabBundles'],
  endpoints: {
    getV2ProviderLabsAvailable: {
      providesTags: ['AvailableLabs'],
    },
    postV2ProviderLabsBundles: {
      invalidatesTags: ['AvailableLabs'], // Refresh available labs to include new bundle
    },
    deleteV2ProviderLabsBundlesByBundleId: {
      invalidatesTags: ['AvailableLabs'], // Refresh available labs after delete
    },
    postV2ProviderLabsOrders: {
      invalidatesTags: [{ type: 'LabOrders' }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Invalidate Entitlements to refresh entitlement usage
          dispatch(subscriptionsApi.util.invalidateTags(['Entitlements']));
        } catch {
          // Error handled by mutation hook
        }
      },
    },
    postV2ProviderLabsOrdersGeneratePdf: {
      // No cache invalidation needed
    },
    postV2ProviderLabsRecommendations: {
      // No cache invalidation needed
    },
    getV2ProviderLabsRecommendationsByTaskId: {
      providesTags: (result, error, arg) => [{ type: 'LabRecommendations', id: arg.taskId }],
    },
  },
});

// Export hooks with friendly names
export const {
  useGetV2ProviderLabsAvailableQuery,
  usePostV2ProviderLabsBundlesMutation,
  useDeleteV2ProviderLabsBundlesByBundleIdMutation,
  usePostV2ProviderLabsOrdersMutation,
  usePostV2ProviderLabsOrdersGeneratePdfMutation,
  usePostV2ProviderLabsRecommendationsMutation,
  useGetV2ProviderLabsRecommendationsByTaskIdQuery,
  useLazyGetV2ProviderLabsRecommendationsByTaskIdQuery,
} = labOrdersApi;
